module.exports = __webpack_public_path__ + "img/dead-tree-desert-02.da44dd6f.png";